/* src/app/components/care/care.component.css */
figure {
  margin: 1rem 0 0 0;
}
figcaption {
  font-size: 0.9rem;
  font-family:
    "Berlin Sans FB",
    Helvetica,
    arial,
    sans-serif;
}
ul.collapsible {
  position: relative;
}
.collapsible > li::before {
  content: url(/assets/fonts/fontawesome/svgs/solid/chevron-down.svg);
  display: block;
  position: absolute;
  right: 20px;
  margin-top: 15px;
  height: 10px;
  width: 10px;
  fill: #7e7e7e;
}
.collapsible > li.active::before {
  content: url(/assets/fonts/fontawesome/svgs/solid/chevron-up.svg);
}
.collapsible-header i {
  height: 20px;
}
.collapsible-header svg.icon {
  margin-right: 20px;
}
.collapsible-body {
  background-color: #fff;
}
@media (max-width: 600px) {
  #collapsible {
    width: 100%;
  }
}
.collection:not(:last-child) {
  margin-bottom: 3rem;
}
.appstore {
  margin: 8px;
}
.qr {
  margin: 0 46px;
  width: 200px;
}
/*# sourceMappingURL=care.component.css.map */
